import TablaConciliacion from "../../../TablaConciliacion";

function TablaViasDelNus() {
  return <TablaConciliacion nombreUseCase="VIASDELNUS" titulo="VIAS DEL NUS" />;
}

export default TablaViasDelNus;
